<template>
	<div class="row">
		<!-- customar project  start -->
		<div class="col-md-12">
			<div class="card">
				<!-- search form -->
				<form
					v-if="user_is_staff_admin"
					@submit.prevent="getForms(null)"
					class="card-header"
				>
					<div class="row">
						<div class="col-md-2">
							<div class="form-group text-center">
								<label class="form-label" for="party_id"
									>Political Party:</label
								>
								<select
									class="form-select"
									id="party_id"
									v-model="params.party_id"
								>
									<option value="">--select--</option>
									<option
										v-for="party in parties"
										:value="party.id"
										:key="'p' + party.id"
									>
										{{ party.abbreviation }}
									</option>
								</select>
							</div>
						</div>
						<div class="col-md-2" style="margin-top: 1.3rem">
							<div class="form-group">
								<LoadingButton
									type="submit"
									class="btn btn-info"
									style="border-radius: 6px"
									>Search</LoadingButton
								>
							</div>
						</div>
					</div>
				</form>
				<div class="card-body">
					<div class="table-responsive">
						<table
							id="data-table"
							class="table table-bordered table-striped mb-0"
						>
							<thead>
								<tr>
									<!-- <th>S/N</th> -->
									<th>Political <br />Party</th>
									<th>Reporting Period</th>
									<th>
										Total Amount <br />
										Received
									</th>
									<th>
										Total Amount <br />
										Expended
									</th>
									<th>
										Total Contributions <br />
										& Donations
									</th>
									<th>Total Asset</th>
									<th>Total Liabilities</th>
									<!-- <th>Approved BY</th> -->
									<th>Submitted BY</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="form in forms.annuals" :key="form.id">
									<!-- <td>{{ index + 1 }}</td> -->
									<td>{{ form.party }}</td>
									<td class="text-center" style="font-size: 12px">
										{{ form.period_from_formatted }}
										<span style="font-weight: 700; color: red">TO</span>
										{{ form.period_to }}
									</td>
									<td>
										<span v-if="form.total_income" class="badge bg-primary">
											{{ form.total_income }}
										</span>
									</td>
									<td>
										<span v-if="form.total_expenses" class="badge bg-danger">
											{{ form.total_expenses }}
										</span>
									</td>
									<td>
										<span
											v-if="form.total_contributions"
											class="badge bg-secondary"
										>
											{{ form.total_contributions }}
										</span>
									</td>
									<td>
										<span v-if="form.total_assets" class="badge bg-secondary">
											{{ form.total_assets }}
										</span>
									</td>
									<td>
										<span
											v-if="form.total_liabilities"
											class="badge bg-secondary"
										>
											{{ form.total_liabilities }}
										</span>
									</td>
									<!-- <td>{{ form.approved_by }}</td> -->
									<td>{{ form.user }}</td>
									<td>
										<div div class="btn-group" role="group">
											<router-link
												:to="`/forms/${form.id}/details/annual-report`"
												class="btn btn-info btn-sm"
												><i class="feather icon-eye"></i
											></router-link>
											<router-link
												v-if="form.is_owner"
												:to="`/forms/${form.id}/annual-report`"
												class="btn btn-warning btn-sm"
												><i class="feather icon-edit"></i
											></router-link>
											<a
												v-if="form.is_owner"
												@click.prevent="deleteForm(form.id)"
												href=""
												class="btn btn-danger btn-sm"
												><i class="feather icon-trash"></i
											></a>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<!-- customar project  end -->

		<template
			v-if="forms && Object.keys(forms).length && forms.paginator.has_pages"
		>
			<Paginator :paginator="forms.paginator" @goto-page="getForms" />
		</template>
	</div>
</template>
<script>
import Paginator from "@/components/Paginator";
import { mapGetters, mapActions } from "vuex";
import Datatable from "@/utils/datatable.js";
import { EventBus } from "@/utils/event_bus.js";
import LoadingButton from "@/components/LoadingButton.vue";
import { userIsStaffAdmin } from "@/utils/permissions";
import Swal from "sweetalert2";

export default {
	name: "ReportingList",
	components: {
		Paginator,
		LoadingButton,
	},
	data() {
		return {
			report: null,
			params: {
				party_id: "",
			},
		};
	},
	computed: {
		...mapGetters({
			forms: "form_ec16c/listForms",
			parties: "settings/parties",
		}),

		user_is_staff_admin() {
			return userIsStaffAdmin();
		},
	},
	methods: {
		...mapActions({
			getFormList: "form_ec16c/getFormList",
			deleteReportRecord: "form_ec16c/deleteReportRecord",
			getParties: "settings/getParties",
		}),

		async getForms(type = null) {
			if (type) {
				if (typeof type === "object") {
					this.params.q = JSON.stringify(type); // Object containing the searchable fields
					this.params.page = null; // Reset page no
				}

				if (typeof type === "string") {
					this.params.page =
						type === "next"
							? parseInt(this.forms.paginator.current_page) + 1
							: parseInt(this.forms.paginator.current_page) - 1;
				}
			}

			await this.getFormList(this.params).then(() => Datatable("#data-table"));
		},

		deleteForm(formID) {
			Swal.fire({
				title: "Delete Record?",
				text: "This action cannot be undone!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#d33",
				cancelButtonColor: "#29623c",
				confirmButtonText: "Yes, delete!",
				cancelButtonText: "Cancel",
			}).then((result) => {
				if (result.isConfirmed) {
					this.sendDeleteRequest(formID);
				}
			});
		},

		async sendDeleteRequest(formID) {
			await this.deleteReportRecord({ formID: formID }).then((res) => {
				if (res.status_code == 200) {
					Swal.fire("Deleted!", res.data.message, "success");
				}
			});
		},

		setReport(report) {
			this.report = report;
			return EventBus.$emit("toggle-modal", "show");
		},
	},
	mounted() {
		this.getForms();
		if (!this.parties.length) {
			this.listParties();
		}
	},
};
</script>
